import { KPI_DECIMALS_MIN, KPI_DECIMALS_MAX } from "@nexus/contracts";

export function clampKpiDecimals(value: number): number {
  if (!Number.isFinite(value)) return KPI_DECIMALS_MIN;
  return Math.min(KPI_DECIMALS_MAX, Math.max(KPI_DECIMALS_MIN, Math.trunc(value)));
}

export function isValidKpiDecimals(value: number): boolean {
  return Number.isInteger(value) && value >= KPI_DECIMALS_MIN && value <= KPI_DECIMALS_MAX;
}
